<template>

  <!-- 技术支持导航菜单区域 -->
<!--  <div  class="support-menu" v-show="showSupportMenu">-->
<!--    <div class="support-options">-->
<!--      <div-->
<!--          v-for="(item, index) in supportItems"-->
<!--          :key="index"-->
<!--          class="support-item"-->
<!--          @click="handleSupportClick(item)"-->
<!--      >-->
<!--        <el-icon><component :is="item.icon" /></el-icon>-->
<!--        <div class="support-title">{{ item.title }}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <!-- 在模板中添加全局加载指示器 -->
  <div v-if="isGlobalLoading" class="global-loading-overlay">
    <div class="global-loading-content">
      <el-icon class="loading-icon" :size="32"><Loading /></el-icon>
      <p class="loading-text">{{ loadingText }}</p>
    </div>
  </div>

  <!-- 头部 -->
  <el-header class="app-header ali-header fixed-header" height="auto">

    <div class="header-container">

      <div class="header-main-nav">
        <!-- Logo -->
        <div class="logo-container" @click="navigateToHome">
          <img src="../assets/logo.gif" alt="易印工具 Logo" class="logo-img">
        </div>

        <!-- 主导航菜单 -->
        <el-menu
            v-if="!isUpdatePasswordPage"
            :default-active="activeMenu"
            mode="horizontal"
            class="ali-nav-menu"
            @select="handleMenuSelect"
        >
          <el-menu-item index="/home">首页</el-menu-item>

          <!-- 产品菜单 - 使用 el-dropdown -->
          <el-dropdown
              placement="bottom"
              trigger="hover"
              :class="{ 'is-active': isProductsMenuActive }"
              class="products-dropdown-wrapper"
          >
            <div class="dropdown-trigger">
              <el-menu-item class="dropdown-menu-item">产品</el-menu-item>
            </div>
            <template #dropdown>
              <!-- 下拉菜单内容 -->
              <div class="products-dropdown">
                <div class="dropdown-content">
                  <!-- 第一列 -->
                  <div class="dropdown-column">
                    <div class="dropdown-category">
                      <h3 class="category-name">图像校对</h3>
                      <div class="category-items">
                        <el-dropdown-item @click="navigateToProductList(1978297871453697)" class="category-item">
                          <el-icon class="item-icon"><position /></el-icon>
                          <span class="item-name">易比图</span>
                        </el-dropdown-item>
                      </div>
                    </div>

                    <div class="dropdown-category">
                      <h3 class="category-name">AI插件</h3>
                      <div class="category-items">
                        <el-dropdown-item @click="navigateToProductList(1)" class="category-item">
                          <el-icon class="item-icon"><position /></el-icon>
                          <span class="item-name">二维码</span>
                        </el-dropdown-item>
                        <el-dropdown-item @click="navigateToProductList(2)" class="category-item">
                          <el-icon class="item-icon"><position /></el-icon>
                          <span class="item-name">智能刀模</span>
                        </el-dropdown-item>
                        <el-dropdown-item @click="navigateToProductList(3)" class="category-item">
                          <el-icon class="item-icon"><position /></el-icon>
                          <span class="item-name">标签管理</span>
                        </el-dropdown-item>
                        <el-dropdown-item @click="navigateToProductList(4)" class="category-item">
                          <el-icon class="item-icon"><position /></el-icon>
                          <span class="item-name">美版能效标签</span>
                        </el-dropdown-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-dropdown>

          <el-menu-item index="/corp" >关于我们</el-menu-item>

        </el-menu>
      </div>

      <!-- 右侧功能区 -->
      <div v-if="!isUpdatePasswordPage" class="header-right-area">
        <!-- 搜索框 -->
        <div class="ali-search-box">
          <el-input
              v-model="searchQuery"
              placeholder="请输入您想搜索的内容"
              class="ali-search-input"
              @keyup.enter="performSearch"
          >
            <template #suffix>
              <el-icon class="search-icon" @click="performSearch"><Search /></el-icon>
            </template>
          </el-input>
        </div>

        <!-- 用户相关 -->
        <div class="user-actions">
<!--          <span v-if="currentUser && currentUser.userType === 'admin'"-->
<!--                class="console-btn"-->
<!--                :class="{ 'active': isConsoleRoute }"-->
<!--                @click="navigateToConsole"-->
<!--          >-->
<!--            控制台-->
<!--                </span>-->

<!--          <span v-if="!currentUser" class="login-action" @click="navigateToLogin">-->
<!--                  登录/注册-->
<!--          </span>-->
          <span v-if="!currentUser" class="login-action" @click="navigateToLogin">
          登录/注册
          </span>

          <el-dropdown v-else @command="handleUserCommand" class="user-dropdown">
            <div class="user-info-wrapper">
              <el-avatar :size="26" :src="currentUser.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" />
              <span class="user-name">{{ currentUser.nickname }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">
                  <el-icon><User /></el-icon>
                  个人中心
                </el-dropdown-item>

                <el-dropdown-item divided command="logout">
                  <el-icon><SwitchButton /></el-icon>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
  </el-header>

  <div class="layout-wrapper">
    <el-container class="layout-container">

      <!-- 移动端Logo（只在移动端显示） -->
      <div class="mobile-logo">
        <img src="@/assets/logo.svg" alt="易印 Logo" class="logo-img">
      </div>

      <!-- 主内容区域 -->
      <el-main class="app-main">
        <router-view />
      </el-main>

      <!-- 底部区域 -->
      <el-footer v-if="!isLrPage" class="app-footer" :class="{ 'reduced-footer': !isHomePage }" height="auto">
        <div class="footer-content" :class="{ 'reduced-layout': !isHomePage }">
          <!-- 首页完整页脚 -->
          <div v-if="isHomePage || isCorpPage" class="footer-main">
            <div class="footer-sections">
              <!-- 网站介绍 -->
              <div class="footer-section">
                <div class="footer-logo">
                  <img src="../assets/logo.gif" alt="易印工具 Logo" class="logo-img">
                  <span class="logo-text">易印工具</span>
                </div>
                <p class="footer-desc">
                  专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
                </p>
              </div>

              <!-- 产品与服务 -->
              <div v-show="!isMobile" class="footer-section">
                <h4 class="section-title">产品与服务</h4>
                <ul class="footer-links">
                  <li><a href="#" >功能介绍</a></li>
                  <li><a href="#" >行业应用</a></li>
                  <li><a href="#" >下载试用</a></li>
                  <li><a href="#" >企业版本</a></li>
                  <li><a href="#" >API 接口</a></li>
                </ul>
              </div>

              <!-- 帮助与支持 -->
              <div v-show="!isMobile" class="footer-section">
                <h4 class="section-title">帮助与支持</h4>
                <ul class="footer-links">
                  <li><a href="#" >使用教程</a></li>
                  <li><a href="#" >常见问题</a></li>
                  <li><a href="#" >技术文档</a></li>
                  <li><a href="#" >联系我们</a></li>
                  <li><a href="#" >意见反馈</a></li>
                </ul>
              </div>

              <!-- 联系方式 -->
              <div class="footer-section">
                <h4 class="section-title">联系方式</h4>
                <div class="contact-info">
                  <div class="contact-item">
                    <el-icon><Message /></el-icon>
                    <span>3052594895@qq.com</span>
                  </div>
                  <div class="contact-item">
                    <el-icon><Phone /></el-icon>
                    <span>18925330037</span>
                  </div>
                  <div class="contact-item">
                    <el-icon><ChatDotRound /></el-icon>
                    <span>微信客服</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 底部版权信息 -->
            <div class="footer-bottom">
              <div class="copyright-section">
                <div class="copyright-text">
                  © 2025 中山市易印网络科技有限公司.保留所有权利.
                </div>

              </div>
              <div class="certification-info">
                <div class="beian-container">
                  <img src="../assets/police.gif" alt="公安备案图标" class="beian-icon">
                  <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                    粤公网安备 44200002443702号
                  </a>
                  <span class="divider">|</span>
                  <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                    粤ICP备16014837号
                  </a>
                </div>
                <div class="legal-links">
                  <a href="/privacyPolicy" @click.prevent="navigateToPrivacyPolicy" class="legal-link">隐私政策</a>
                  <span class="divider">|</span>
                  <a href="/userAgreement" @click.prevent="navigateToUserAgreement" class="legal-link">用户协议</a>
                  <span class="divider">|</span>
                  <a href="#" class="legal-link">法律声明</a>
                </div>
              </div>
            </div>
          </div>

          <!-- 非首页简化页脚 -->
          <div v-else class="footer-simple">
            <div class="footer-bottom simple">
              <!-- 第一行：版权信息 -->
              <div class="copyright-section">
                <div class="copyright-text">
                  © 2025 中山市易印网络科技有限公司.保留所有权利.
                </div>
              </div>

              <!-- 第二行：备案信息 -->
              <div class="certification-info">
                <div class="beian-container">
                  <img src="../assets/police.gif" alt="公安备案图标" class="beian-icon">
                  <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                    粤公网安备 44200002443702号
                  </a>
                  <span class="divider">|</span>
                  <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                    粤ICP备16014837号
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-footer>

      <!-- 移动端底部导航栏 -->
      <div class="mobile-bottom-nav" v-show="isMobile">
        <!-- 移动端导航项保持不变 -->
        <div :width="160">
          <div class="mobile-nav-item" @click="navigateToHome()">
            <div class="nav-text">首页</div>
          </div>
        </div>

        <el-dropdown
            placement="top"
            trigger="click"
            :width="160"
            :visible="popoverVisibleB"
            @visible-change="popoverVisibleB = $event">
          <div class="mobile-nav-item">
            <div class="nav-text">搜索</div>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="mobile-dropdown-menu">
              <el-dropdown-item>搜索人才</el-dropdown-item>
              <el-dropdown-item>搜索任务</el-dropdown-item>
              <el-dropdown-item>发布任务</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <el-dropdown
            placement="top"
            trigger="click"
            :width="160"
            router
            :visible="popoverVisibleC"
            @visible-change="popoverVisibleC = $event">
          <div class="mobile-nav-item">
            <div class="nav-text">菜单</div>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="mobile-dropdown-menu">
              <el-dropdown-item @click="handleMenuSelect('/pluginlist')">插件列表</el-dropdown-item>
              <el-dropdown-item>人才雇佣</el-dropdown-item>
              <el-dropdown-item>任务大厅</el-dropdown-item>
              <el-dropdown-item>印前素材</el-dropdown-item>
              <el-dropdown-item>印前课堂</el-dropdown-item>
              <el-dropdown-item>印前社区</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>

        <div :width="160">
          <div class="mobile-nav-item">
            <div class="nav-text">我的</div>
          </div>
        </div>
      </div>
    </el-container>

  </div>

</template>


<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, markRaw, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  Search, User, Monitor, SwitchButton, ArrowRight, Position,
  ChatDotRound, Phone, Document, VideoCamera }
  from '@element-plus/icons-vue';
import request from '@/utils/request';
import { ElMessage } from 'element-plus';
import { eventBus } from '@/utils/eventBus'

const router = useRouter();
const route = useRoute();

// 响应式数据
const searchQuery = ref('');
const activeMenu = ref('/');
const isMobile = ref(false);
const popoverVisibleB = ref(false);
const popoverVisibleC = ref(false);

// 全局用户状态
const currentUser = eventBus.getGlobalUser()

// 添加全局加载状态
const isGlobalLoading = ref(false)
const loadingText = ref('')

// 技术支持项
const supportItems = ref([
  {
    icon: markRaw(ChatDotRound),
    title: '在线客服',
    route: '/user-chat' // 添加路由信息
  }
  // { icon: markRaw(Phone), title: '电话支持' },
  // { icon: markRaw(Document), title: '文档中心' },
  // { icon: markRaw(VideoCamera), title: '视频教程' }
])

// 技术支持菜单点击处理
const handleSupportClick = (item) => {
  if (item.title === '在线客服') {
    navigateToIM();
  }
  // 可以在这里添加其他菜单项的处理逻辑
};

const enterpriseFormRef = ref(null);

// 计算属性
const isLrPage = computed(() => {
  return route.path === '/login' || route.path === '/register' || route.path === '/bind-phone' || route.path === '/updatePassword';
});

const isUpdatePasswordPage = computed(() => {
  return route.path === '/updatePassword';
});

const isHomePage = computed(() => {
  return route.path === '/' || route.path === '/home';
});

const isCorpPage = computed(() => {
  return route.path === '/corp';
});

const isConsoleRoute = computed(() => {
  return route.path.startsWith('/console');
});

const isProductsMenuActive = computed(() => {
  return route.path.includes('/products') || route.path.includes('/pluginlist');
});

// 是否显示技术支持菜单
const showSupportMenu = computed(() => {
  return route.path !== '/user-chat' && route.path !== '/customer-service';
});

// 监听路由变化
watch(() => route.path, (newPath) => {
  activeMenu.value = newPath;

  // 登录页面时隐藏滚动条
  if (newPath === '/login' || newPath === '/register' || newPath === '/updatePassword') {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
}, { immediate: true });

// 方法
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};


const handleUserCommand = (command) => {
  switch (command) {
    case 'profile':
      router.push('/profile');
      break;
    case 'logout':
      handleLogout();
      break;
  }
};

const navigateToLogin = () => {
  router.push('/login');
};

const navigateToHome = () => {
  router.push('/');
};

const navigateToIM = () => {
  console.log('🔄 点击在线客服，检查用户身份...');

  // 先检查是否有token（是否登录）
  const token = localStorage.getItem('auth_token');

  console.log('Token状态:', token);

  if (!token) {
    console.log('用户未登录，直接跳转到用户聊天页面');
    router.push('/user-chat');
    return;
  }

  console.log('用户已登录，检查客服身份...');

  // 有token，检查是否为客服
  request.get('/im/customer-service/check')
      .then(response => {
        console.log('客服身份检查响应:', response);

        if (response.code === '200' && response.data.isCustomerService) {
          console.log('✅ 用户是客服，跳转到客服工作台');
          router.push('/customer-service');
        } else {
          console.log('❌ 用户不是客服，跳转到用户聊天页面');
          router.push('/user-chat');
        }
      })
      .catch(error => {
        console.error('检查客服身份失败:', error);
        // 检查失败时默认跳转到用户聊天页面
        router.push('/user-chat');
      });
}

const navigateToConsole = () => {
  router.push('/console');
};

const navigateToPrivacyPolicy = () => {
  router.push('/privacyPolicy');
}

const navigateToUserAgreement = () => {
  router.push('/userAgreement');
}

const navigateToProducts = (productName) => {
  router.push({
    path: '/products',
    query: { name: productName }
  });
};

const navigateToProductList = (id) => {
  router.push(`/products?id=${id}`);
};

const handleMenuSelect = (index) => {
  router.push(index);
};

const performSearch = (type = '') => {
  if (searchQuery.value.trim()) {
    const path = type === 'artist' ? '/search/artist' :
        type === 'mission' ? '/search/mission' : '/search';

    router.push({
      path,
      query: { q: searchQuery.value.trim() }
    });
    searchQuery.value = '';
  }
};

// 获取用户信息
const getCurrentUserInfo = async () => {
  const token = localStorage.getItem('auth_token');

  if (!token) {
    eventBus.clearUser();
    return;
  }

  try {
    isGlobalLoading.value = true
    loadingText.value = '正在加载用户信息...'

    const res = await request.get('/user/current');
    eventBus.setUser(res.data);

    // 添加短暂延迟确保状态完全更新
    await new Promise(resolve => setTimeout(resolve, 200));

  } catch (error) {
    console.error('获取当前用户信息失败:', error);
    // 如果获取用户信息失败，清除无效token
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
    }
    eventBus.clearUser();
  } finally {
    isGlobalLoading.value = false
    loadingText.value = ''
  }
};

// 处理登录成功的方法
const handleLoginSuccess = async () => {
  isGlobalLoading.value = true
  loadingText.value = '登录成功，正在加载...'

  try {
    // 确保token已经存储
    await new Promise(resolve => setTimeout(resolve, 300));

    // 获取用户信息
    await getCurrentUserInfo();

    // 再次短暂延迟确保状态更新完成
    await new Promise(resolve => setTimeout(resolve, 200));

  } finally {
    isGlobalLoading.value = false
    loadingText.value = ''
  }
}

// 监听登录事件
eventBus.onLogin(handleLoginSuccess)

// 退出登录
const handleLogout = async () => {
  try {
    const token = localStorage.getItem('auth_token');

    if (token) {
      await request.post('/auth/logout');
    }

    localStorage.removeItem('auth_token');
    eventBus.clearUser(); // 使用 eventBus 清除用户
    ElMessage.success('退出登录成功');
    router.push('/home');
  } catch (error) {
    console.error('退出登录失败:', error);
    localStorage.removeItem('auth_token');
    eventBus.clearUser(); // 使用 eventBus 清除用户
    router.push('/home');
  }
};

// 处理函数
const handleLoginRefresh = () => {
  // 重新获取用户信息
  getCurrentUserInfo()
}

// 处理用户信息更新的方法
const handleUserProfileUpdated = (updateData) => {
  if (!currentUser.value) return

  // console.log('收到用户信息更新:', updateData)

  if (updateData.type === 'avatar') {
    // 更新头像
    currentUser.value.avatar = updateData.data
    // 同时更新 eventBus 中的全局用户信息
    eventBus.setUser({ ...currentUser.value, avatar: updateData.data })
  } else if (updateData.type === 'nickname') {
    // 更新昵称
    currentUser.value.nickname = updateData.data
    // 同时更新 eventBus 中的全局用户信息
    eventBus.setUser({ ...currentUser.value, nickname: updateData.data })
  }

  ElMessage.success('用户信息已更新')
}

// 生命周期钩子
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
  getCurrentUserInfo();
  // 监听登录事件
  eventBus.onLogin(handleLoginRefresh)

  // 监听用户信息更新事件
  eventBus.on('user-profile-updated', handleUserProfileUpdated)
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
  // 移除监听
  eventBus.offLogin(handleLoginRefresh)

  eventBus.off('user-profile-updated', handleUserProfileUpdated)
});

</script>

<style>
/* 全局样式 - 消除默认边距 */
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>

<style scoped>

.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1); /* 非常透明的背景 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  animation: fadeIn 0.4s ease-out;
}

/* 移除白色背景，只保留图标 */
.global-loading-content {
  text-align: center;
  background: transparent; /* 透明背景 */
  padding: 0; /* 移除内边距 */
  box-shadow: none; /* 移除阴影 */
  border-radius: 0; /* 移除圆角 */
  animation: none; /* 移除缩放动画 */
}

.loading-icon {
  color: #409EFF;
  animation: spin 1.2s linear infinite;
  margin-bottom: 0; /* 移除下边距 */
}

/* 隐藏文本 */
.loading-text {
  display: none;
}

/* 使用相同的动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(12px);
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 技术支持菜单样式 */
.support-menu {
  position: fixed;
  right: 20px !important;
  top: 80% !important;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 10px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;
  padding: 15px 10px !important;
  z-index: 1001;
}

.support-options {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
}

.support-item {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  cursor: pointer !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  transition: all 0.3s !important;
  gap: 8px !important;
}

.support-item:hover {
  background: #f5f7fa !important;
  transform: translateY(-2px) !important;
}

.support-item .el-icon {
  font-size: 24px !important;
  color: #f54012 !important;
}

.support-title {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #333 !important;
}

/* 固定头部样式 */
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: linear-gradient(90deg, #fefdfd 0%, #f8fafe 100%);
  border-bottom: 1px solid #e4e5e6;
}

/* 头部 */
.ali-header {
  background: linear-gradient(90deg, #fefdfd 0%, #f8fafe 100%);
  color: #333; /* 添加文字颜色确保可读性 */
  border-bottom: 1px solid #e4e5e6; /* 添加底部边框增加层次感 */
  padding: 0;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
}

.header-main-nav {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 20px;
}

.logo-img {
  height: 50px;
  width: auto;
  -ms-interpolation-mode: bicubic; /* 改善缩放算法 */
}

.logo-text {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

/* 导航菜单 */
.ali-nav-menu {
  background: transparent;
  border: none;
  height: 60px;
  flex: 1; /* 使菜单占据剩余空间 */
  min-width: 0; /* 允许内容收缩 */
  overflow: hidden; /* 隐藏溢出内容 */
}


:deep(.ali-nav-menu .el-menu-item) {
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  border-bottom: none;
  padding: 0 12px;
  margin: 0 2px;
  white-space: nowrap; /* 防止文字换行 */
  position: relative; /* 为箭头定位做准备 */
  transition: all 0.3s ease; /* 添加过渡效果 */
}

:deep(.ali-nav-menu .el-sub-menu) {
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  border-bottom: none;
  padding: 0 12px;
  margin: 0 2px;
  white-space: nowrap; /* 防止文字换行 */
  position: relative; /* 为箭头定位做准备 */
  transition: all 0.3s ease; /* 添加过渡效果 */
}

:deep(.ali-nav-menu .el-menu-item:hover),
:deep(.ali-nav-menu .el-menu-item.is-active),
:deep(.ali-nav-menu .el-sub-menu:hover .el-sub-menu__title),
:deep(.ali-nav-menu .el-sub-menu.is-active .el-sub-menu__title) {
  background: transparent !important;
  color: #3370ff !important; /* 保持蓝色作为激活状态 */
  border-bottom: none;
}

/* 添加箭头指示器 */
:deep(.ali-nav-menu .el-menu-item:hover)::after,
:deep(.ali-nav-menu .el-menu-item.is-active)::after,
:deep(.ali-nav-menu .el-sub-menu:hover .el-sub-menu__title)::after,
:deep(.ali-nav-menu .el-sub-menu.is-active .el-sub-menu__title)::after {
  content: '';
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #3370ff; /* 创建向上箭头 */
  transition: all 0.3s ease;
}

/* 确保菜单项不会被隐藏 */
:deep(.ali-nav-menu) .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
:deep(.ali-nav-menu) .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background-color: transparent !important;
}

/* 添加下拉菜单包装器样式 */
.products-dropdown-wrapper {
  height: 60px;
  display: flex;
  align-items: center;
}

.dropdown-trigger {
  height: 100%;
  outline: none !important;
}

:deep(.products-dropdown-wrapper .dropdown-menu-item) {
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  border-bottom: none;
  padding: 0 12px;
  margin: 0 2px;
  white-space: nowrap;
  position: relative;
  transition: all 0.3s ease;
}

:deep(.products-dropdown-wrapper.is-active .dropdown-menu-item) {
  color: #3370ff !important;
}

:deep(.products-dropdown-wrapper.is-active .dropdown-menu-item)::after {
  content: '';
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #3370ff;
  background: transparent !important;
}

/* 调整下拉菜单项样式 */
:deep(.products-dropdown-wrapper .el-dropdown-menu) {
  padding: 0;
  border: none;
}

:deep(.products-dropdown-wrapper .el-dropdown-menu__item) {
  padding: 0;
}

:deep(.products-dropdown-wrapper .category-item) {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease;
  color: #4a4a4a;
  position: relative;
  width: 100%;
}

:deep(.products-dropdown-wrapper .category-item:hover) {
  background: #f5f7fa;
  color: #0066cc;
}

:deep(.ali-nav-menu .el-sub-menu .el-sub-menu__title) {
  height: 60px;
  line-height: 60px;
  color: #666;
  font-size: 16px;
  font-weight: 600;
  border-bottom: none;
  padding: 0 12px;
  margin: 0 2px;
  white-space: nowrap;
  position: relative;
  transition: all 0.3s ease;
}

:deep(.ali-nav-menu .el-sub-menu .el-sub-menu__title:hover) {
  color: #3370ff !important;
}

:deep(.ali-nav-menu .el-sub-menu .el-sub-menu__icon-arrow) {
  display: none !important;
}

/* 下拉菜单内容样式 - 多列布局 */
.products-dropdown {
  width: 300px;
  padding: 0;
  overflow: hidden;
}

@keyframes dropdownFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-content {
  display: flex;
  padding: 24px;
  gap: 30px;
}

.dropdown-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dropdown-category {
  margin-bottom: 0;
}

.category-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1d29;
  margin: 0 0 12px 0;
  padding-bottom: 6px;
  border-bottom: 1px solid #e8e9ea;
  line-height: 1.2;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  letter-spacing: 0.2px;
}

.category-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.category-item {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease;
  color: #4a4a4a;
  position: relative;
}

.category-item:hover {
  background: #f5f7fa;
  color: #0066cc;
}

/* 添加图标样式 */
.item-icon {
  color: #3370ff;
  margin-right: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
}

.category-item:hover .item-name {
  color: #2952cc;
  transform: translateX(6px);
}

.item-name {
  font-size: 14px;
  font-weight: 400;
  color: inherit;
  line-height: 1.3;
  transition: all 0.2s ease;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  letter-spacing: 0.1px;
}

/* 右侧区域 */
.header-right-area {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-shrink: 0;
}

/* 搜索框 */
.ali-search-box {
  width: 260px;
}

:deep(.ali-search-input .el-input__wrapper) {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: none;
  height: 32px;
}

:deep(.ali-search-input .el-input__inner) {
  color: #333;
  height: 20px;
  line-height: 32px;
}

:deep(.ali-search-input .el-input__inner::placeholder) {
  color: #999;
  font-size: 12px;
}

:deep(.ali-search-input .el-input__wrapper:hover) {
  border-color: #c0c4cc;
}

:deep(.ali-search-input .el-input__wrapper.is-focus) {
  border-color: #3370ff;
  box-shadow: 0 0 0 1px #3370ff inset !important;
}

.search-icon {
  color: #666;
  cursor: pointer;
  font-size: 16px;
}

.search-icon:hover {
  color: #3370ff;
}

/* 用户操作区 */
.user-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.console-btn {
  color: #666;
  cursor: pointer;
  font-size: 12px;
}

.console-btn:hover {
  color: #3370ff !important;
}

.console-btn.active {
  color: #3370ff !important;
}

.login-action {
  color: #666;
  cursor: pointer;
  font-size: 13px;
}

.login-action:hover {
  color: #3370ff;
}

.user-dropdown {
  cursor: pointer;
  margin-left: 5px;
}

.user-info-wrapper {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  border-radius: 4px;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;

}

.user-info-wrapper:hover {
  background-color: rgba(73, 80, 87, 0.08);
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.user-name {
  margin: 0 6px; /* 减少边距 */
  font-size: 14px; /* 缩小字体 */
  color: #2d2c2c; /* 调整颜色 */
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "微软雅黑", sans-serif;
  font-weight: 500; /* 增加字重 */
}

/* 下拉菜单样式 */
:deep(.user-dropdown .el-dropdown-menu__item) {
  display: none !important;
  align-items: center;
  font-size: 13px; /* 缩小下拉菜单字体 */
  padding: 8px 12px; /* 调整内边距 */

  &::after {
    display: none !important;
  }
}

:deep(.user-dropdown .el-icon) {
  margin-right: 6px; /* 减少图标右边距 */
  font-size: 14px; /* 调整图标大小 */
}

.layout-wrapper {
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  margin-top: 60px;
}

.layout-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #fff;
  overflow: visible;
  min-height: 0;
}

.app-footer {
  background: linear-gradient(135deg, #1a1f36 0%, #2d1b69 100%);
  color: rgba(255, 255, 255, 0.8);
  padding: 0;
  border-top: none;
  flex-shrink: 0;
}

.footer-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 首页完整页脚 */
.footer-main {
  padding: 60px 20px 20px;
}

.footer-sections {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.2fr;
  gap: 40px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-section:first-child {
  padding-right: 20px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.footer-logo .logo-img {
  height: 40px;
  width: auto;
  margin-right: 12px;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  background: linear-gradient(45deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.footer-desc {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  font-size: 0.95rem;
  margin: 0;
}

.section-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(45deg, #ff7e5f, #feb47b);
  border-radius: 1px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-links a:hover {
  color: #ff7e5f;
  transform: translateX(5px);
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

.contact-item .el-icon {
  color: #ff7e5f;
  font-size: 1.1rem;
}

/* 底部版权区域 */
.footer-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.copyright-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 200px;
}

.copyright-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

.legal-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legal-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.3s ease;
}

.legal-link:hover {
  color: #ff7e5f;
  cursor: pointer !important;
}

.divider {
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.8rem;
}

.certification-info {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.beian-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.beian-icon {
  height: 16px;
  width: auto;
}

.beian-link, .icp-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.8rem;
  transition: color 0.3s ease;
}

.beian-link:hover, .icp-link:hover {
  color: #ff7e5f;
}

/* 非首页简化页脚 */
.footer-simple {
  padding: 20px;
}

.footer-bottom.simple {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  gap: 20px;
}

.footer-bottom.simple .copyright-section {
  flex-direction: row;
  align-items: center;
  gap: 20px;
}

.footer-bottom.simple .certification-info {
  justify-content: flex-end;
}

/* 移动端适配 */
@media (max-width: 992px) {
  .header-container {
    width: 100%;
    padding: 0 15px;
  }

  .ali-search-box {
    width: 200px;
  }
}

@media (max-width: 768px) {

  .layout-wrapper {
    margin-top: 0; /* 移动端不需要margin-top */
    padding-bottom: 60px; /* 为底部导航栏留出空间 */
  }

  .fixed-header {
    display: none !important;
  }

  .layout-scrollbar {
    margin-top: 0;
  }

  /* 隐藏顶部菜单和搜索栏 */
  .app-header {
    display: none !important;
  }

  /* 只显示Logo */
  .mobile-logo {
    display: flex !important;
    justify-content: center;
    padding: 15px 0;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  .app-main {
    flex: 1;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: #fff;
    overflow: visible;
  }

  .app-footer {
    padding-bottom: 60px; /* 为移动端底部导航栏留出空间 */
  }

  .footer-main {
    padding: 30px 15px 15px;
  }

  .footer-sections {
    grid-template-columns: 1fr;
    gap: 30px;
    margin-bottom: 20px;
    padding-bottom: 20px;
  }

  .footer-section:first-child {
    padding-right: 0;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .copyright-section {
    flex-direction: column;
    gap: 10px;
  }

  .certification-info {
    flex-direction: column;
    gap: 10px;
  }

  .legal-links {
    justify-content: center;
  }

  /* 移动端底部导航栏 */
  .mobile-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }

  .mobile-nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
  }

  .mobile-nav-item:hover {
    background: #f8f8f8;
  }

  .nav-text {
    font-size: 16px;
    color: #666;
  }

  /* 移动端下拉菜单样式 */
  .mobile-dropdown-menu {
    border-radius: 12px;
    padding: 8px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .mobile-dropdown-menu .el-dropdown-menu__item {
    font-size: 14px;
    padding: 10px 16px;
    color: #333;
    transition: all 0.2s;
  }

  .mobile-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }

  .mobile-dropdown-menu .el-dropdown-menu__item:hover {
    background-color: #fef0f0;
    color: #f54012;
  }

  /* 在移动端显示Logo */
  .mobile-logo {
    display: flex;
    justify-content: center;
    padding: 15px 0;
    background: #fff;
    border-bottom: 1px solid #eee;
  }

  .mobile-logo .logo-img {
    width: 120px;
    height: auto;
  }

  .footer-simple {
    padding: 15px 10px;
  }

  .footer-bottom.simple {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .footer-bottom.simple .copyright-section {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .footer-bottom.simple .certification-info {
    justify-content: center;
    width: 100%;
  }

  .footer-bottom.simple .copyright-text {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.4;
  }

  .footer-bottom.simple .beian-container {
    justify-content: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .footer-bottom.simple .beian-link,
  .footer-bottom.simple .icp-link {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.6);
  }

  .footer-bottom.simple .divider {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.4);
  }

  .footer-bottom.simple .beian-icon {
    height: 14px;
  }

}

@media (min-width: 769px) {
  .mobile-logo {
    display: none !important;
  }
}

/* 在移动端添加移动端Logo容器 */
.mobile-logo {
  display: none;
}

@media (max-width: 480px) {
  .footer-simple {
    padding: 12px 8px;
  }

  .footer-bottom.simple {
    gap: 10px;
  }

  .footer-bottom.simple .copyright-text {
    font-size: 0.75rem;
  }

  .footer-bottom.simple .beian-link,
  .footer-bottom.simple .icp-link {
    font-size: 0.7rem;
  }

  .footer-bottom.simple .beian-container {
    gap: 4px;
  }
}
</style>

